import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.5 20a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    d: "M14.329 8.172A3.99 3.99 0 0 0 11.5 7a3.99 3.99 0 0 0-2.828 1.172M17.611 17.611l4.242 4.243"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }